<template>
    <div>
        <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center"
                     style="min-height: 60px; background-image: url(img/theme/profile-cover.jpg); background-size: cover; background-position: center top;">
            <!-- Mask -->
            <span class="mask bg-gradient-success opacity-8"></span>
            <!-- Header container -->
            <div class="container-fluid d-flex align-items-center">
                <div class="row">
                    <div class="col-lg-7 col-md-10">
                        <!-- <h1 class="display-2 text-white">Washing Machine</h1> -->
                        <!-- <p class="text-white mt-0 mb-5"></p> -->
                        <!-- <a href="#!" class="btn btn-info">Edit profile</a> -->
                    </div>
                </div>
            </div>
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col-xl-12 order-xl-1">
                    <card shadow type="secondary">
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-8">
                                    <h3 class="mb-0">สร้าง QRCode</h3> 
                                    <a href="https://docs.justwash.asia/tutorial/printqr" style="color: #007aff; font-size: 14px;   font-weight: 400;" target="_blank">View tutorial</a>
                                </div>
                                <!-- <div class="col-4 text-right">
                                    <a href="#!" class="btn btn-sm btn-primary">Settings</a>
                                </div> -->
                            </div>
                        </div>
                        <template>
                            <div class="pl-lg-4">
                              <div class="text-center">
                                <base-alert type="default" v-show="isLoading">
                                    <i class="ni ni-world-2"></i> กำลังโหลดกรุณารอสักครู่...
                                </base-alert>
                                <button class="btn btn-success" @click="isLoading = true" v-on:click="qrcode()">พิมพ์ QRCode</button>
                              </div>
                            </div>
                        </template>
                    </card>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  import JwService from '../service/justwash';

  export default {
    name: 'user-profile',
    data() {
      // console.log(this.washingData);
      return {
        washingData : {},
        qrcodeData : {},
        isLoading: false
      }
    },
    methods: {
      qrcode:function() {
        this.isLoading = true;
        // console.log('qrcode');
        // alert('กำลังโหลดกรุณารอสักครู่...');
        axios({
          method: 'post',
          url: JwService.getAPI()+'/api/method/justwash.OwnerApi.GetQrCodePdf',
          data: {},
          headers: {
            'Authorization' : 'Token '+localStorage.getItem('accessToken')
          }
        }).then((response) => {
          // console.log(this.qrcodeData);
          if (response.data.message.status == true) {
            this.qrcodeData = response.data.message.data.data;
            // console.log(this.qrcodeData);
            // this.$router.push('/setting/'+this.$route.params.id);
            this.isLoading = false;
            window.location.href = this.qrcodeData;
          } else {
            this.$router.push('/login');
          }
        }).catch(error => {
          console.log(error);
          this.$router.push('/login');
        });
      }
    }
  };
</script>
<style></style>
